class CreateFacility {
	constructor(
		public readonly organizationId: number,
		public readonly name: string,
		public readonly address: string | null,
		public readonly phoneNumber: string | null,
	) {
		Object.freeze(this);
	}

	// `organizationId` is the route identifier: it must never be echoed in the request body.
	toJSON(): Record<string, unknown> {
		return {
			name: this.name,
			address: this.address,
			phoneNumber: this.phoneNumber,
		};
	}
}

export default CreateFacility;
